import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class ImportListTable extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    count: PropTypes.number.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };
  render = () => {
    const {
      children,
      company,
      subcompany,
      permissions,
      handleToggle = () => {},
      handleReImportCSV = (uno, dos, tres) => {
        alert('falta desarrollo');
      },
      t = (value) => value,
    } = this.props;

    const headers = [
      {
        variable: 'createdAt',
        text: t('import.fields.createdAt') + ': ',
        type: 'h3',
      },
      { variable: 'status', text: t('import.fields.status') + ': ' },
      { variable: 'modulo', text: t('import.fields.module') + ': ' },
      { variable: 'updated', text: t('import.fields.updated') + ': ' },
      { variable: 'inserted', text: t('import.fields.inserted') + ': ' },
      { variable: 'fail', text: t('import.fields.fail') + ': ' },
      { variable: 'warnings', text: t('import.fields.warnings') + ': ' },
      // {
      //   variable: "active",
      //   text: t("import.fields.active") + ": ",
      //   boolean: true,
      // },
    ];

    const config = {
      // actions: t("common.actions"), //Texto de seccion de acciones
      edit: t('common.edit'), //Texto de boton editar

      // editPermission: "acl.imports.update",/////// Eliminar
      // togglePermission: "acl.imports.toggle",/////// Eliminar

      mostrarDetalles: '',
      generarCSV: '',
      reimportar: '',

      editUrl: 'imports', //Url para editar empleado
      propsName: 'record', //de donde se obtienen los props
      company: company,
      subcompany: subcompany,
      importingModule: true,
      handleReImportCSV: handleReImportCSV,
    };

    const dataCard = {
      rows: children,
      headers: headers,
      config: config,
      permissions: permissions,
      handleClick: handleToggle,
      t: t,
    };
    console.log(dataCard);

    return (
      <Common.List dataCard={dataCard}>
        <thead>
          <tr>
            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="createdAt"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('import.fields.createdAt')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="status"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.status')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="module"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.module')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="updated"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.updated')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="inserted"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.inserted')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="fail"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.fail')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="warnings"
              handleOrderChange={this.props.handleOrderChange}
              className="text-center"
            >
              {this.props.t('import.fields.warnings')}
            </Common.ThSortable>
            <th className="text-center">{this.props.t('import.fields.actions')}</th>
          </tr>
        </thead>

        <tbody>
          {this.props.count === 0 && <Common.EmptyTable colSpan={20} />}
          {this.props.children}
        </tbody>
      </Common.List>
    );
  };
}

export default translate()(ImportListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/list/ImportListTable.js